import { render, staticRenderFns } from "./StrategyTab.vue?vue&type=template&id=98af28de&scoped=true"
import script from "./StrategyTab.vue?vue&type=script&lang=js"
export * from "./StrategyTab.vue?vue&type=script&lang=js"
import style0 from "./StrategyTab.vue?vue&type=style&index=0&id=98af28de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98af28de",
  null
  
)

export default component.exports